import styled from 'styled-components';
import React from 'react';
import { AltEConsultLogo } from 'assets/branding';
import { H1 } from 'styles/elements/headers';
import { Div } from 'styles/elements/div';
import media from 'styles/media';

const NavigationBar = styled(Div)`
  background-color: ${props => props.theme.brandingSecondaryShadeOne};
  padding: 30px 20px 20px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-shrink: 0;
`;

const RestartButton = styled.button`
  background: ${props => props.theme.alertColor};
  font-size: 24px;
  color: white;
  font-weight: bold;
  border-radius: 13px;
  border: none;
  padding: 15px;
  margin-left: 20px;
  cursor: pointer;
  ${media.extraSmallAndBelow`
    font-size: 12px;
  `}
`;

const SectionWrapper = styled(Div)`
  flex-wrap: wrap;
`;

const StyledAltEConsultLogo = styled(AltEConsultLogo)`
  height: 50px;
  margin-bottom: -6px;
  ${media.extraSmallAndBelow`
    height: 25px;
  `}
`;

const ApiVersionNumber = styled(H1)`
  color: white;
  margin: 0;
  ${media.extraSmallAndBelow`
    font-size: 18px;
  `}
`;

NavigationBar.RestartButton = RestartButton;
NavigationBar.EConsultLogo = StyledAltEConsultLogo;
NavigationBar.SectionWrapper = SectionWrapper;

export const ConstructedNavigationBar = ({ onButtonClick, isClinicalReviewMode, apiVersion }) => (
  <NavigationBar>
    <SectionWrapper style={{ flex: '1 1 auto' }}>
      <NavigationBar.EConsultLogo />
      <NavigationBar.RestartButton onClick={() => onButtonClick()}>Restart Consultation</NavigationBar.RestartButton>
    </SectionWrapper>
    <SectionWrapper>
      {isClinicalReviewMode && apiVersion ? <ApiVersionNumber>Consultation API Version {apiVersion}</ApiVersionNumber> : null}
    </SectionWrapper>
  </NavigationBar>
);

export default NavigationBar;
